import { Directive, OnDestroy, Input, TemplateRef, ElementRef, ViewContainerRef, HostListener } from "@angular/core";
import { OverlayService } from "../services/overlay.service";
import { ConnectedPosition } from "@angular/cdk/overlay";

@Directive({
    selector:'[appOverlay]',
    standalone:true
})
export class OverlayDirective implements OnDestroy {

    @Input('appOverlay') template!: TemplateRef<any>;
    @Input() overlayContext: any;
    @Input() positions: ConnectedPosition[] = [];
    @Input() originWidth: boolean = true;
    @Input() overlayDisabled = false;

    private isOpen = false;
    private initialized = false;

    constructor(private el: ElementRef, private overlayService: OverlayService, private vcr: ViewContainerRef) {
        setTimeout(() => this.initialized = true, 0);
    }

    open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.overlayService.open(
            this.el, this.template, this.vcr,
            this.positions, this.originWidth, this.overlayContext
        ).subscribe(() => {
            // backdrop closed the overlay
            this.isOpen = false;
        });
    }

    @HostListener('click', ['$event'])
    toggle(e: MouseEvent) {
        if (this.overlayDisabled) return;
        // ignore clicks that originated from a child input (search box)
        if ((e.target as HTMLElement).tagName === 'INPUT') return;

        if (this.isOpen) {
            this.overlayService.close();
            this.isOpen = false;
        } else {
            this.open();
        }
    }

    @HostListener('focusin', ['$event'])
    onFocusIn(e: FocusEvent) {
        if (!this.initialized || this.overlayDisabled) return;
        // open when the inner input receives focus
        if ((e.target as HTMLElement).tagName === 'INPUT') {
            this.open();
        }
    }

    closeOverlay() {
        this.overlayService.close();
        this.isOpen = false;
    }

    @HostListener('document:keydown.escape')
    onEsc() {
        this.closeOverlay();
    }

    ngOnDestroy(): void {
        this.overlayService.close();
    }
}
